import styled from 'styled-components';
import { motion } from 'framer-motion';

export const Container = styled(motion.aside)`
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 999;
`;
